import React, {Component} from "react";
import {translate} from "react-polyglot";
import {Button, Col, Input, Row} from "reactstrap";
import styled from "styled-components";

const StyledHr = styled.hr`
  height: 0.25rem;
  width: 100%;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
`;

interface IProps {
  id: string;
  parameter: string;
  allowedValues: IAllowedValues;
  value: string;
  handleValueChange: (id: string, value: number[]) => void;
}

interface IAllowedValues {
  increment: number;
  minValue: number;
  maxValue: number;
}

class BasicSlider extends Component<IProps & TranslateProps> {
  constructor(props: any) {
    super(props);
    this.reset = this.reset.bind(this);
  }

  public reset() {
    const { id, handleValueChange } = this.props;
    if(handleValueChange) {
      handleValueChange(id, [])
    }
  }

  public render() {
    const {
      allowedValues,
      id,
      parameter,
      t,
      value,
      handleValueChange
    } = this.props;

    return (
      <Col className="pt-2" key={id}>
        <Row>
          <Col>
            <label htmlFor={parameter}>
              {t(`parameters.${parameter}`)}:{value}
            </label>
          </Col>
          <Col className="text-right">
            <Button size="sm" outline onClick={() => this.reset()}>Reset</Button>
          </Col>
        </Row>
        <Input
          id={parameter}
          type="range"
          step={allowedValues.increment}
          min={allowedValues.minValue}
          max={allowedValues.maxValue}
          value={value}
          onChange={(e: any) => handleValueChange(id, [e.target.value])}
          className="custom-range border-0"
        />
        <StyledHr className="mb-0 mt-3 " />
      </Col>
    );
  }
}

export default translate()(BasicSlider);
